import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {PricePlanBundleRequestsService} from "../../services/price-plan-bundle-requests.service";

export class PricePlanBundleListViewComponent implements IController {

  bundles: any[] = [];
  loading: boolean = false;

  constructor(private pricePlanBundleRequestsService: PricePlanBundleRequestsService, private $log) {
  }

  $onInit() {
    this.loadAllBundles();
  }

  refreshList() {
    this.loadAllBundles();
  }

  private sortList(list) {
    list = _.orderBy(list, [
      function (elem) {
        return elem.isDefault;
      },
      function (elem) {
        return elem.name ? elem.name.toLowerCase() : '';
      }
    ], ['desc', 'asc']);
    return list;
  }

  private loadAllBundles() {
    this.loading = true;
    this.bundles = [];

    this.pricePlanBundleRequestsService.getAllBundles()
      .then((allBundles) => {
        this.bundles = this.sortList(allBundles);
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to get all bundles @pricePlanBundleListView@_loadAllBundles', error)
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('pricePlanBundleListView', {
    bindings: {},
    template: require('./price-plan-bundle-list-view.html').default,
    controller: PricePlanBundleListViewComponent
  });
